import styled from "styled-components";
import { useState, useRef, useEffect } from "react";
import { gql, useQuery, useLazyQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import AutoresponderMessagePreview from "./AutoresponderMessagePreview";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import RoundActionIcon from "components/buttons/RoundActionIcon";

import crossIcon from "assets/img/icons/icons8-cross.svg";

const AutoresponderMessagePreviewContainer = styled.div`
  position: relative;

  flex: 1;

  display: flex;
`;

const PreviewModalWrap = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 100%;
  max-width: 1200px;
  padding: 0 10px;
  box-sizing: border-box;
  z-index: 2000;
`;

const PreviewModal = styled.div`
  position: relative;
  margin-top: 30px;
  width: 100%;
  padding: 25px 0px;
  box-sizing: border-box;
  height: calc(100vh - 120px);
  transform: translateY(-25px);

  overflow-y: auto;

  border-radius: ${css.BOX_RADIUS_PRIMARY};
  background: ${css.BLUE_BOX_GRADIENT};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  @media (min-width: ${globalConstants.switchMobile}) {
    margin-top: 0px;
  }
`;

const PreviewHeader = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: ${globalConstants.switchMobile}) {
    margin-top: 0px;
    padding: 0 25px;
  }
`;

const PreviewTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
`;

const CloseBox = styled.div`
  align-self: flex-start;
`;

export default ({ messageId, closePreview }) => {
  // Fetch data
  const GET_RESPONDER_MESSAGE_DATA = gql`
    query GetResponderMessageData($messageId: ID!) {
      responderMessageData(messageId: $messageId) {
        id
        subject
        html
      }
    }
  `;

  const { data, error } = useQuery(GET_RESPONDER_MESSAGE_DATA, {
    variables: {
      messageId,
    },
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("error fetching responder message data", error);
    captureException(error);
  }

  console.log("data", data);

  return (
    <AutoresponderMessagePreviewContainer>
      {!data && (
        <PreviewModalWrap>
          <LoadingBox>
            <BoxLoadingSpinner height="435px" />
          </LoadingBox>{" "}
        </PreviewModalWrap>
      )}
      {data && (
        <PreviewModalWrap>
          <PreviewModal>
            <PreviewHeader>
              <PreviewTitle>{data.responderMessageData.subject}</PreviewTitle>
              <CloseBox>
                <RoundActionIcon
                  icon={crossIcon}
                  iconAlt="Close"
                  onClick={closePreview}
                />
              </CloseBox>
            </PreviewHeader>
            <AutoresponderMessagePreview data={data} />
          </PreviewModal>
        </PreviewModalWrap>
      )}
    </AutoresponderMessagePreviewContainer>
  );
};
